// extracted by mini-css-extract-plugin
export default {"panel":"ActionPanel-module__panel___nV_E0"};